import React from 'react';

//Components
import { DataGrid as BaseDataGrid } from '@mui/x-data-grid';

//Css
import styled from 'styled-components';

const Root = styled.div`
  height: 600px;
  width: 100%;
`;

export const DataGrid = props => {
  const { rows, columns, handleColumnVisibilityModelChange, handleHeaderSelectionCheckboxChange, ...otherProps } =
    props;
  return (
    <Root>
      <BaseDataGrid
        rows={rows}
        columns={columns}
        checkboxSelection
        onColumnVisibilityModelChange={handleColumnVisibilityModelChange}
        onSelectionModelChange={handleHeaderSelectionCheckboxChange}
        {...otherProps}
      />
    </Root>
  );
};
